<script setup>
import { useI18n } from 'vue-i18n';
import LaisSelect from 'dashboard/components-next/LaisSelect.vue';

defineProps({
  period: { type: Object, required: true },
  months: { type: Array, required: true },
  years: { type: Array, required: true },
});

const emit = defineEmits(['setPeriod']);
const { t } = useI18n();
const updatePeriod = (key, value) =>
  emit('setPeriod', { [key]: Number(value) });
</script>

<template>
  <div class="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
    <h2 class="text-lg font-semibold text-lais-text">
      {{ t('POST_SALE.MANAGEMENT.DEEDS_TEAM') }}
    </h2>
    <div class="grid gap-3 sm:grid-cols-2">
      <label
        class="flex flex-col gap-1 text-sm font-medium text-lais-text-body"
      >
        {{ t('POST_SALE.MANAGEMENT.DEEDS_MONTH') }}
        <LaisSelect
          :model-value="period.month"
          :options="months"
          :placeholder="t('POST_SALE.MANAGEMENT.SELECT')"
          @update:model-value="updatePeriod('month', $event)"
        />
      </label>
      <label
        class="flex flex-col gap-1 text-sm font-medium text-lais-text-body"
      >
        {{ t('POST_SALE.MANAGEMENT.DEEDS_YEAR') }}
        <LaisSelect
          :model-value="period.year"
          :options="years"
          :placeholder="t('POST_SALE.MANAGEMENT.SELECT')"
          @update:model-value="updatePeriod('year', $event)"
        />
      </label>
    </div>
  </div>
</template>
